import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.conversation.WmBranchQuoteSupportEditor.';
  public static readonly editDraftComments = `${Id.prefix}editDraftComments`;
  public static readonly editComments = `${Id.prefix}editComments`;
  public static readonly addComments = `${Id.prefix}addComments`;
  public static readonly specialItem = `${Id.prefix}specialItem`;
  public static readonly supportRequest = `${Id.prefix}supportRequest`;
  public static readonly comments = `${Id.prefix}comments`;
}

export class LangBranchQuoteSupportEditor {
  private constructor() {}
  public static editDraftComments(): string {
    return interpolate(Id.editDraftComments);
  }
  public static editComments(): string {
    return interpolate(Id.editComments);
  }
  public static addComments(): string {
    return interpolate(Id.addComments);
  }
  public static specialItem(): string {
    return interpolate(Id.specialItem);
  }
  public static supportRequest(): string {
    return interpolate(Id.supportRequest);
  }
  public static comments(): string {
    return interpolate(Id.comments);
  }
}

export class WmBranchQuoteSupportEditorModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.editDraftComments, 'Edit Draft Comments', 'Header for editing draft comments');
    register.add(Id.editComments, 'Edit Comments', 'Header for editing comments');
    register.add(Id.addComments, 'Add Comments', 'Header for adding comments');
    register.add(Id.specialItem, "{{glossary 'special-item'}}", 'Label for special item');
    register.add(Id.supportRequest, "{{glossary 'support-request'}}", 'Label for support request');
    register.add(Id.comments, 'Comments', 'Section header for comments');
  }
}
